import { render, staticRenderFns } from "./MessageComposerModal.vue?vue&type=template&id=579cadfd&scoped=true"
import script from "./MessageComposerModal.vue?vue&type=script&lang=js"
export * from "./MessageComposerModal.vue?vue&type=script&lang=js"
import style0 from "./MessageComposerModal.vue?vue&type=style&index=0&id=579cadfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579cadfd",
  null
  
)

export default component.exports